import script from "./TemplateSelectModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./TemplateSelectModal.vue?vue&type=script&lang=ts&setup=true"

import "./TemplateSelectModal.vue?vue&type=style&index=0&id=6a44eb0d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a44eb0d"]])

export default __exports__